export default __webpack_public_path__ + "static/media/logoAIDay_Plan de travail 1.2f14986d.png";